import React, { useEffect, useState } from "react";
import { PageHeader, EmptyState } from "@/components/Layout";
import api, { API } from "@/lib/api";

export default function ExpiringDocuments() {
  const [rows, setRows] = useState(null);

  useEffect(() => { api.get("/employee-files/documents/expiring").then(r => setRows(r.data)); }, []);

  if (!rows) return <div style={{ padding: 40 }}>Se încarcă...</div>;

  return (
    <>
      <PageHeader title="Documente ce expiră" subtitle={`${rows.length} documente în următoarele 30 de zile`} />
      <div className="card">
        <table className="tbl">
          <thead><tr><th>Marcă</th><th>Angajat</th><th>Structură</th><th>Document</th><th>Expiră</th><th className="tabular-nums">Zile rămase</th><th></th></tr></thead>
          <tbody>{rows.map(d => (
            <tr key={d.id} data-testid={`expiring-row-${d.marca}`}>
              <td style={{ fontWeight: 600 }} className="tabular-nums">{d.marca}</td>
              <td>{d.employee_name || "—"}</td>
              <td>{d.org_unit_name || "—"}</td>
              <td>{d.original_filename}</td>
              <td>{d.expiry_end}</td>
              <td className="tabular-nums" style={{ fontWeight: 700, color: d.days_left <= 7 ? "#DC2626" : "#334155" }}>{d.days_left}z</td>
              <td>
                <a className="btn btn-secondary" style={{ padding: "3px 10px", fontSize: 12 }}
                  href={`${API}/employee-files/documents/${d.id}/download`} target="_blank" rel="noreferrer">Descarcă</a>
              </td>
            </tr>
          ))}</tbody>
        </table>
        {rows.length === 0 && <EmptyState text="Niciun document nu expiră în perioada următoare." />}
      </div>
    </>
  );
}
